import { SupportAnchorLink } from "./SupportAnchorLink";
import { Typography } from "@mui/material";
import React from "react";

export const AuthFooter = (): JSX.Element => {
  return (
    <Typography
      variant="body2"
      sx={{
        m: 2,
        textAlign: "center",
      }}
    >
      If you are having difficulties signing in, please contact us at:
      <br />
      <SupportAnchorLink />
    </Typography>
  );
};
